export enum FileType {
    PDF = "application/pdf"
}
